/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNav_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyRespTopNavFilters_viewer">;
    readonly " $refType": "BuyRespTopNav_viewer";
};
export type BuyRespTopNav_viewer$data = BuyRespTopNav_viewer;
export type BuyRespTopNav_viewer$key = {
    readonly " $data"?: BuyRespTopNav_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyRespTopNav_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNav_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyRespTopNavFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'c24149c3c9ceb6bfbaea61859e76fc90';
export default node;
